var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPisces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 24.9998H45.8327M10.416 7.2915C10.416 7.2915 16.666 17.5207 16.666 24.9998C16.666 32.479 10.416 42.7082 10.416 42.7082M39.5827 7.2915C39.5827 7.2915 33.3327 17.6665 33.3327 24.9998C33.3327 32.3332 39.5827 42.7082 39.5827 42.7082",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPisces);
export default __webpack_public_path__ + "static/media/pisces.fbdc451d509e1cd3883942e117408094.svg";
export { ForwardRef as ReactComponent };